var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var UIModelUserSkeleton = /** @class */ (function () {
    function UIModelUserSkeleton(params) {
        this.name = params.name;
        this.email = params.email;
        this.picture = params.picture;
        this.nickname = params.nickname;
        if (params.auth0UserId) {
            this.auth0UserId = params.auth0UserId;
        }
    }
    return UIModelUserSkeleton;
}());
var UIModelProfile = /** @class */ (function (_super) {
    __extends(UIModelProfile, _super);
    function UIModelProfile(response) {
        var _this = _super.call(this, response) || this;
        _this.roles = response.roles;
        _this.permissions = response.permissions;
        _this.emailVerified = response.emailVerified;
        return _this;
    }
    return UIModelProfile;
}(UIModelUserSkeleton));
export { UIModelProfile };
var UIModelProfileApp = /** @class */ (function () {
    function UIModelProfileApp(response) {
        this.id = response.id;
        this.name = response.name;
        this.organisation = response.organisation;
        this.permissions = response.permissions;
    }
    return UIModelProfileApp;
}());
export { UIModelProfileApp };
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoidXNlci5tb2RlbC5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbInVzZXIubW9kZWwudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7Ozs7Ozs7Ozs7Ozs7O0FBT0E7SUFPRSw2QkFBWSxNQUF5QjtRQUNuQyxJQUFJLENBQUMsSUFBSSxHQUFHLE1BQU0sQ0FBQyxJQUFJLENBQUM7UUFDeEIsSUFBSSxDQUFDLEtBQUssR0FBRyxNQUFNLENBQUMsS0FBSyxDQUFDO1FBQzFCLElBQUksQ0FBQyxPQUFPLEdBQUcsTUFBTSxDQUFDLE9BQU8sQ0FBQztRQUM5QixJQUFJLENBQUMsUUFBUSxHQUFHLE1BQU0sQ0FBQyxRQUFRLENBQUM7UUFDaEMsSUFBSSxNQUFNLENBQUMsV0FBVyxFQUFFO1lBQ3RCLElBQUksQ0FBQyxXQUFXLEdBQUcsTUFBTSxDQUFDLFdBQVcsQ0FBQztTQUN2QztJQUNILENBQUM7SUFDSCwwQkFBQztBQUFELENBQUMsQUFoQkQsSUFnQkM7QUFFRDtJQUFvQyxrQ0FBbUI7SUFLckQsd0JBQVksUUFBMkI7UUFBdkMsWUFDRSxrQkFBTSxRQUFRLENBQUMsU0FJaEI7UUFIQyxLQUFJLENBQUMsS0FBSyxHQUFHLFFBQVEsQ0FBQyxLQUFLLENBQUM7UUFDNUIsS0FBSSxDQUFDLFdBQVcsR0FBRyxRQUFRLENBQUMsV0FBVyxDQUFDO1FBQ3hDLEtBQUksQ0FBQyxhQUFhLEdBQUcsUUFBUSxDQUFDLGFBQWEsQ0FBQzs7SUFDOUMsQ0FBQztJQUNILHFCQUFDO0FBQUQsQ0FBQyxBQVhELENBQW9DLG1CQUFtQixHQVd0RDs7QUFFRDtJQU1FLDJCQUFZLFFBQThCO1FBQ3hDLElBQUksQ0FBQyxFQUFFLEdBQUcsUUFBUSxDQUFDLEVBQUUsQ0FBQztRQUN0QixJQUFJLENBQUMsSUFBSSxHQUFHLFFBQVEsQ0FBQyxJQUFJLENBQUM7UUFDMUIsSUFBSSxDQUFDLFlBQVksR0FBRyxRQUFRLENBQUMsWUFBWSxDQUFDO1FBQzFDLElBQUksQ0FBQyxXQUFXLEdBQUcsUUFBUSxDQUFDLFdBQVcsQ0FBQztJQUMxQyxDQUFDO0lBQ0gsd0JBQUM7QUFBRCxDQUFDLEFBWkQsSUFZQyJ9